import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Icon, notification} from 'antd';
import {getCategories, searchCategories, showDeleteCategoryModal, updateCategoryVisibility} from './actions';
import {bindActionCreators} from "redux";
import {Link} from "react-router-dom";
import ListView from "../common/ListView";
import {getTaxGroups} from "../Tax/actions";
import DeleteCategoryFormModal from "./DeleteCategoryFormModal";

class CategoriesPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    /* state */
    loading: PropTypes.bool.isRequired,
    search: PropTypes.object.isRequired,
    allCategories: PropTypes.array.isRequired,
    dispensaryId: PropTypes.string.isRequired,
    taxGroups: PropTypes.array.isRequired,
    deleteCategoryModalVisible: PropTypes.bool.isRequired,
    /* actions */
    searchCategories: PropTypes.func.isRequired,
    updateCategoryVisibility: PropTypes.func.isRequired,
    getCategories: PropTypes.func.isRequired,
    getTaxGroups: PropTypes.func.isRequired,
    showDeleteCategoryModal: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (this.props.dispensaryId !== prevProps.dispensaryId) this.load();
  }

  load = () => {
    const {dispensaryId, getCategories, getTaxGroups} = this.props;
    if (dispensaryId) {
      getCategories({dispensaryId});
      getTaxGroups({dispensaryId});
    }
  };

  onVisibilityClick = async(values) => {
    try {
      await this.props.updateCategoryVisibility(values);
      this.listView.refresh();
    } catch (err) {
      notification.error({
        message: 'Failed changing visibility',
        description: err.message,
      });
    }
  };

  render() {
    const {
      history, searchCategories, dispensaryId, taxGroups, allCategories, deleteCategoryModalVisible,
      search: {searching, pagination, filters, sorter, searchFilter, results},
    } = this.props;
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true,
      },
      {
        title: 'Parent',
        dataIndex: 'parentName',
        key: 'parentId',
        sorter: true,
        filters: allCategories.map(({categoryId: value, name: text}) => ({text, value})),
        render: (parentName, {parentVisibleOnTill}) =>
          <span
            style={parentVisibleOnTill ? {} : {textDecoration: 'line-through'}}
          >
            {parentName}
          </span>
      },
      {
        title: 'Tax Group',
        dataIndex: 'taxGroupName',
        key: 'taxGroupId',
        sorter: true,
        filters: taxGroups.map(({taxGroupId: value, name: text}) => ({text, value})),
      },
      {
        title: 'Visibility',
        key: 'visibility',
        render: (value, {categoryId, visibleOnTill, parentVisibleOnTill}) =>
          <Icon
            type="shopping-cart"
            style={{color: parentVisibleOnTill && visibleOnTill ? 'green' : 'red', cursor: 'pointer'}}
            onClick={() => parentVisibleOnTill
              ? this.onVisibilityClick({categoryId, visibleOnTill: !visibleOnTill})
              : notification.warning({message: 'Invalid action', description: 'Parent category is not visible'})
            }
          />
      },
      {
        title: 'Action',
        key: 'action',
        render: (_, category) => {
          return (<span><Link to={`/category/update/${encodeURIComponent(category.categoryId)}`}>Edit</Link> | <a
            onClick={() => this.props.showDeleteCategoryModal(category)}>Delete</a> </span>);
        }
      }
    ];
    return (<React.Fragment>
      {deleteCategoryModalVisible && <DeleteCategoryFormModal onDelete={() => this.listView.refresh()}/>}
      <ListView
        ref={ref => this.listView = ref}
        dispensaryId={dispensaryId}
        title="Categories"
        loading={searching}
        columns={columns}
        dataSourceProvider={searchCategories}
        dataSource={results}
        pagination={pagination}
        searchFilter={searchFilter}
        filters={filters}
        sorter={sorter}
        onAdd={() => history.push('/category/add')}
        rowKey="categoryId"
      />
    </React.Fragment>);
  }
}

const mapStateToProps = state => ({
  loading: state.category.searching || state.category.categoriesLoading || state.tax.taxGroupsLoading,
  dispensaryId: state.dispensary.selectedDispensaryId,
  taxGroups: state.tax.taxGroups,
  search: state.category.search,
  allCategories: state.category.categories,
  deleteCategoryModalVisible: state.category.deleteCategoryModalVisible,

});

const mapDispatchToProps = dispatch => (bindActionCreators({
  searchCategories,
  updateCategoryVisibility,
  getTaxGroups,
  getCategories,
  showDeleteCategoryModal,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(CategoriesPage);



// WEBPACK FOOTER //
// ./src/Category/CategoriesPage.js